import {type MechanicBarbarianInvasionState, type NestedReadonly, TileCornerBuildingType} from '@colonist/game-states'
import {MechanicValidator} from './MechanicValidator.ts'
import {type PlayerValidator} from '../core/PlayerValidator.ts'
import {type MapValidator} from '../core/map/MapValidator.ts'

export class MechanicValidatorBarbarianInvasion extends MechanicValidator {
    private readonly barbarianInvasionState: NestedReadonly<MechanicBarbarianInvasionState>
    static readonly PROGRESS_WHEN_BARBARIANS_ATTACK = 7

    constructor(playerValidators: PlayerValidator[], mapValidator: MapValidator, barbarianInvasionState: NestedReadonly<MechanicBarbarianInvasionState>) {
        super(playerValidators, mapValidator)

        this.barbarianInvasionState = barbarianInvasionState
    }

    getBarbarianStrength(): number {
        let barbarianStrength: number = 0
        for(const tileCorner of this.mapValidator.tileState.tileCorners) {
            if(tileCorner.owner === undefined) continue
            if(tileCorner.buildingType !== TileCornerBuildingType.City) continue

            barbarianStrength += 1
        }

        return barbarianStrength
    }

    getBarbarianProgress(): number {
        return this.barbarianInvasionState.barbarianProgress
    }
}
